import { getToken } from '../services/auth';
import React from 'react';

const Token = () => {
  return (
    <div
      style={{
        fontFamily: 'monospace',
        overflowWrap: 'break-word',
        padding: 20,
      }}
    >
      {getToken()}
    </div>
  );
};

export default Token;
